{
    "OnavailablestateLabel": "Ein Verfügbar Zustand vorbei:",
    "OnbusystateLabel": "Bei Besetztzustand vorbei:",
    "OnnaordndstateLabel": "Bei N\/A oder DND State Over:",
    "OnwrapupLabel": "Bei Nachbearbeitungszustand vorbei:",
    "OnavailablestateEnabledHiddenlabel": "Ist die Einstellung „Ein verfügbarer Zustand über“ aktiviert?",
    "OnbusystateEnabledHiddenlabel": "Ist die Einstellung „Besetztzustand über“ aktiviert?",
    "OnnaordndstateEnabledHiddenlabel": "Ist „On N\/A“ oder „DND State Over Setting“ aktiviert?",
    "OnwrapupEnabledHiddenlabel": "Ist die Einstellung „On Wrap-Up State Over“ aktiviert?",
    "OnavailablestatePlaceholder": "30er",
    "OnbusystatePlaceholder": "5m 0s",
    "OnnaordndstatePlaceholder": "3m 0s",
    "OnwrapupPlaceholder": "3m 0s",
    "ACDStateThresholds_SectionHeader": "ACD-Zustandsschwellenwerte",
    "ACDStateThresholds_SectionPara": "Sie können Alarme aktivieren, wenn Agenten zu lange in einem bestimmten ACD-Zustand bleiben. Wählen Sie unten die ACD-Zustände, die einen Alarm auslösen sollen, und wählen Sie dann die gewünschte Aktivierungsdauer.",
    "NAME": "ACDStateThresholds"
}